import { ModuleBase, ResponsiveImage } from '@/components';
import classNames from 'classnames';
import React from 'react';

const IconListModule = ({ data }) => {
  const { iconListElements } = data;

  return (
    <ModuleBase data={{ ...data }} className={'font-montserrat color-from-bg pt-10 pb-10 bg-background-secondary'}>
      <div className={classNames('container  flex flex-col gap-8 justify-between ')}>
        <div className={classNames('icon-item  lg:w-[782px] flex flex-col w-full mb-6 last:mb-0  lg:mb-10')}>
          {iconListElements.map((icons, index) => (
            <div
              key={index}
              className={classNames(
                'icon-wrapper w-full flex items-center gap-3 py-4 border-b color-from-bg border-opacity-10 md:last:pb-0 last:border-none',
              )}
            >
              <div className={`icon aspect-square w-6 h-6 `}>
                <ResponsiveImage
                  image={icons.logo}
                  widths={{ xs: 24, sm: 24, md: 24, lg: 24, xl: 24, xxl: 24 }}
                  heights={{ xs: 24, sm: 24, md: 24, lg: 24, xl: 24, xxl: 24 }}
                  image-class="h-full w-full object-cover"
                  className=" h-full w-full object-cover"
                />
              </div>
              <div className={classNames('text w-[81%]')}>
                <p className={classNames('text-base not-italic font-normal leading-6.5')}>{icons.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </ModuleBase>
  );
};

export default IconListModule;
